<template>
    <div :class="getStatusHeader.header.minimaze ? 'headerIncomeWidget_wrap' : 'headerIncomeWidget_wrap-minimaze'">
        <div :class="getStatusHeader.header.minimaze ? 'headerIncomeWidget_title' : 'headerIncomeWidget_title headerIncomeWidget_title-minimaze'">
            <div :class="getStatusHeader.header.minimaze ? 'headerIncomeWidget_text' : 'headerIncomeWidget_text headerIncomeWidget_text-minimaze'">
               {{this.pair.title}}
            </div>
            <div class="headerIncomeWidget_menuIcon" @click="openMenu()">
                <i :class="menuQuote ? 'icon-icon-up' : 'icon-icon-down'"></i>
            </div>
        </div>
        <div :class="getStatusHeader.header.minimaze ? 'headerIncomeWidget_dataItem-wrap' : 'headerIncomeWidget_dataItem-wrap-minimaze'">
            <div :class="getStatusHeader.header.minimaze ? 'headerIncomeWidget_dataItem' : 'headerIncomeWidget_dataItem headerIncomeWidget_dataItem-minimaze'">
                <watcher :data="getQuote.bid" :units="'q'">
                </watcher>
            </div>
            <div class="headerIncomeWidget_dataWrap">
                <div :class="getStatusHeader.header.minimaze ? 'headerIncomeWidget_dataItemPoint' : 'headerIncomeWidget_dataItemPoint headerIncomeWidget_dataItemPoint-minimaze'">
                    <span :class="getPoint < 0 ? 'color-red':'color-green'">{{getPoint}}</span>
                </div>
                <div :class="getStatusHeader.header.minimaze ? 'headerIncomeWidget_dataItemPercent' : 'headerIncomeWidget_dataItem headerIncomeWidget_dataItemPercent-minimaze'">
                    <span :class="getPercent < 0 ? 'color-red':'color-green'">{{'(' + getPercent + ' %)'}}</span>
                </div>
            </div>
        </div>
        <div class="menuIcon" v-show="menuQuote">
            <div class="menuIcon_row">
                <div class="menuIcon_item" v-for="(item,index) in quotesMenu" :key="index" @click="setMenu(item)">
                    {{item.title}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import Description from '../ui-components/description'
import Watcher from '../ui-components/ui-data-watcher'
import axios from 'axios';
export default {
    components: {
        'des':Description,
        'watcher':Watcher
    },
    props: {
        pair:{default:{ }}
    },
    data() {
        return {
        menuQuote: false,
        quotesMenu: [
            {
                title:'AUD/USD',
                symbol:'AUDUSD'
            },
            {
                title:'BTC/USD',
                symbol:'BTCUSD'
            },
            {
                title:'ETH/USD',
                symbol:'ETHUSD'
            },
            /*{
                title:'EUR/RUB',
                symbol:'EURRUB'
            },*/
            {
                title:'EUR/USD',
                symbol:'EURUSD'
            },
            {
                title:'GBP/USD',
                symbol:'GBPUSD'
            },
            {
                title:'NZD/USD',
                symbol:'NZDUSD'
            },
            {
                title:'USD/CHF',
                symbol:'USDCHF'
            },
            {
                title:'USD/JPY',
                symbol:'USDJPY'
            },
            {
                title:'USD/RUB',
                symbol:'USDRUB'
            },
        ],
        dataDay:[]
        };
    },
    methods: {
        openMenu () {
            this.menuQuote = !this.menuQuote;
        },
        setMenu(symbol) {
            this.$emit('newSymbol', symbol);
            axios
                .get('https://api.iqquantum.com/api/bars?ticker=' + this.pair.name + '&timeframe=1140&count=1')
                .then(response => (this.dataDay = response.data));
            this.menuQuote = false;
        }
    },
    computed: {
        ...mapGetters({
            getStatusHeader:'usersets/getSettings',
            quotes: "quotes/getQuotes",
            filteredQuotes: "quotes/getFilteredQuotes"
        }),
        getQuote() {
            let quote = {
                   bid:0
            }
            if(this.quotes[this.pair.name])
                quote = {
                   bid:this.quotes[this.pair.name].bid
               }
            return quote;
        },
        getPoint() {
            if(this.dataDay.length === 0 || this.getQuote.bid === 0)
                return 0
            else
                return (this.getQuote.bid - this.dataDay[this.dataDay.length - 1].open).toFixed(5);
        },
        getPercent() {
            if(this.dataDay.length === 0 || this.getQuote.bid === 0)
                return 0
            else
                return ((100/(this.dataDay[this.dataDay.length - 1].open/this.getQuote.bid)) - 100).toFixed(5);
        }
    },
    mounted() {
        axios
            .get('https://api.iqquantum.com/api/bars?ticker=' + this.pair.name + '&timeframe=1140&count=5')
            .then(response => (this.dataDay = response.data));
        setInterval(() => {axios
            .get('https://api.iqquantum.com/api/bars?ticker=' + this.pair.name + '&timeframe=1140&count=5')
            .then(response => (this.dataDay = response.data));
        }, 60000);
    }
    }
</script>
<style lang="less" scoped>
@keyframes change-padding {
    from {
        padding: 8px 12px 12px 12px;
    }
    to {
        padding: 4px 12px 12px 12px;
    }
}
@keyframes change-padding-full {
    from {
        padding: 4px 12px 12px 12px;
    }
    to {
        padding: 8px 12px 12px 12px;
    }
}
.headerIncomeWidget {
    &_dataWrap {
        display: flex;
        align-items: center;
    }
    &_menuIcon {
        font-size: 14px;
        color:#ADC4E1;
        cursor: pointer;
    }
  &_wrap {
    animation: change-padding-full 0.6s ease-in 1;
    display: flex;
    flex-direction: column;
    background: #3d536b;
    margin-right: 1px;
    padding: 8px 12px 12px 12px;
    box-sizing: border-box;
    flex-grow: 1;
    height: 100%;
    min-width: 170px;
    position: relative;

    &-minimaze {
        animation: change-padding 0.6s ease-in 1;
        display: flex;
        flex-direction: column;
        background: #3d536b;
        margin-right: 1px;
        padding: 4px 12px 12px 12px;
        flex-grow: 1;
        height: 88px;
        min-width: 130px;
    }
  }

  &_title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    max-height: 20px;
    margin-bottom:8px;
    &-minimaze {
        margin-bottom: 0px;
        min-height: 15px;
    }
  }

  &_text {
    font-family: Arimo;
    font-size: 13px;
    //font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.6;
    letter-spacing: 0.4px;
    color: #ADC4E1;
    max-height: 16px;
    text-transform: uppercase;
    &-minimaze {
        font-size: 10px;
        font-weight: 600;
    }
  }

  &_balance {
    font-family: Arimo;
    font-size: 16px;
    //font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: normal;
    color: @colors[green];
    margin-bottom: 0px;
    display: flex;
    align-items: center;
  }

  &_data {
    display: flex;
  }

  &_dataItem {
    font-family: Arimo;
    font-weight: 600;
    font-size: 20px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: normal;
    color: #0fd7b7;
    margin-right: 4px;
    width: 100%;
    display:flex;
    justify-content: space-between;
    span {
        color:#ADC4E1;
    }
    &-minimaze {
        line-height: 1;
        font-size: 18px;
    }
    &-wrap {
        display: block;
        &-minimaze {
            display: flex;
        }
    }
  }
  &_dataItemPoint {
        font-family: Arimo;
        font-weight: 600;
        font-size: 16px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1;
        letter-spacing: normal;
        color: #0fd7b7;
        width: 100%;
        display:flex;
        margin-top: 8px;
        justify-content: space-between;
        &-minimaze {
            font-size: 14px;
            margin-top: 0px;
        }
  }
  &_dataItemPercent {
        font-family: Arimo;
        font-weight: 600;
        font-size: 13px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1;
        letter-spacing: normal;
        color: #0fd7b7;
        width: 100%;
        display:flex;
        margin-top: 8px;
        justify-content: space-between;
        &-minimaze {
            display: none;
        }
  }

  &_maxdd {
    font-family: Arimo;
    font-size: 10px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: 0.4px;
    color: @colors[red];
    margin-top: 4px;
  }
}
.menuIcon {
    position: absolute;
    top:23px;
    right: 12px;
    z-index: 2;
    &_row {
        position: fixed;
        background: #324258;
        transform: translateX(-100%);
    }
    &_item {
        font-family: 'Arimo';
        cursor: pointer;
        font-weight: 600;
        font-size: 12px;
        color:#9FB6D2;
        padding: 6px 10px 6px 10px;
        border-bottom: 1px solid #293546;
    }
}
</style>
